












import { Component, Prop, Vue } from 'vue-property-decorator';
import * as Common from '@/tenant/common';

@Component
export default class TradeSideBar extends Vue {

  public countOrder:number = null;
  public countDelivery:number= null;
  public countInvoice:number= null;  
  public countCharge:number= null;

  public created() {
    this.$api.addEventListener('workflow',this.reload);
  }
  public destroyed() {
    this.$api.removeEventListener('workflow',this.reload);
  }
  public mounted(){
    this.reload();
  }
  public reload(){    
    this.$api.execute(new Common.TaskCountQuery('PurchaseTaskCountQuery', false)).then(res =>{
      var hash = res as { [key: string]: number};
      this.countOrder = hash.PurchaseOrder;
      this.countDelivery = hash.PurchaseDelivery;
      this.countInvoice = hash.PurchaseInvoice;
      this.countCharge = hash.PurchaseCharge;
    });
  }
}
